import * as React from 'react';
import { connectNLP } from '../../../../utilities/connect-navigate';
import { getQuery, replaceQuery } from '../../../../utilities/helper-fuctions';
import { Form } from '../../form/form';
import { formatOptions } from '../../inputs/select/formatter';
import { Select } from '../../inputs/select/select';
import './per-page.scss';

const defaultOptions: any = [{ value: '10' }, { value: '50' }, { value: '100' }];

class PerPageComponent extends React.Component<any, any> {
    public form = new Form({
        size: {
            value: getQuery().size || formatOptions(defaultOptions)[0].value,
            trigger: () => this.handleSizeChange(),
        },
    });

    public handleSizeChange() {
        const size = this.form.getValue('size');

        if (size !== this.previousPage) {
            const newQuery = replaceQuery({ size: size, page: 0 });
            this.props?.router?.navigate({ search: newQuery });
            this.previousPage = size;
        }
    }

    public previousPage: any = getQuery().size || formatOptions(defaultOptions)[0].value;

    public componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        if (prevProps?.router?.location?.search !== this.props?.router?.location?.search) {
            const newSize = getQuery().size || formatOptions(defaultOptions)[0].value;
            this.previousPage = newSize;
            this.form.setValue('size', newSize);
        }
    }

    public render(): React.ReactElement {
        return (
            <form>
                <Select
                    field={this.form.getField('size')}
                    classes="SelectSizeComponent"
                    options={formatOptions(defaultOptions, false)}
                />
            </form>
        );
    }
}

export const PerPage: any = connectNLP(PerPageComponent);
